export default __webpack_public_path__ + "static/media/1.7c3d5aa9.jpg";